export const RECENTLY_SOLD_LIMIT = {
  /**
   * 메인 페이지에서 보이는 섹션의 limit
   */
  MAIN: 5,

  /**
   * Shop > Now 리스트에서 보이는 limit
   */
  LIST: 100,
} as const;

export const POLLING_DURATION_ms = 10 * 1000;
